import React, { useEffect } from "react";

//Local imports
import ButtonRightIconGreen from "modules/Common/Components/ButtonRightIconGreen";
import PlusIcon from "../../../../assets/img/CuratedContent/Plus.svg";
import PalletButtonSection from "../../AdHocEmail/PalletButtonSection";
import FloatingPopover from "modules/Common/Components/FloatingPopover";
import FloatingPopoverData from "../../Reminders/FloatingPopoverData";
import { RootState } from "../../../../store/index";
import Message from "../../../Common/Components/Message";
import ButtonSmall from "../../../Common/Components/ButtonSmall";
import { useSelector } from "react-redux";
import EmailCardWrapper from "../../Shared/EmailCardWrapper";
import EmailCardWrapperLoader from "../../Shared/EmailCardWrapperLoader";
import { getQueryParam } from "utils";
import { getQueryCampaignId } from "modules/EmailBrowser/utils";
import styled from "styled-components";
import CreateAsset from "modules/Campaigns/CampaignAssets/Components/CreateAsset";
import { IVersion } from "modules/Campaigns/interfaces";
import { createNewDraftVersionAssetWithoutCampaign } from "../actions";
import { ASSET_TYPE } from "../../../../constants/index";
import { ALERT_MESSAGES } from "constants/messages";
import store from "store";
interface IAssetWithoutCampaignDashboard { }

const AssetWithoutCampaignDashboard: React.FC<IAssetWithoutCampaignDashboard> = (prop) => {
  const assetId = getQueryParam("asset_id");
  // const draftEditions: IVersion[] = useSelector(
  //   (state: RootState) => state.assetWithoutCampaignDetails.draftEditions
  // );

  let draftEditions: any[] = store.getState().assetWithoutCampaignDetails.draftEditions;
  const loading: boolean = useSelector((state: RootState) => state.assetWithoutCampaignDetails.loading);
  const assetName: string = useSelector((state: RootState) => state.assetWithoutCampaignDetails.assetName);

  const newDraftLoading: boolean = useSelector(
    (state: RootState) => state.assetWithoutCampaignDetails.addNewDraft.loading
  );

  const updateDraftSuccess: boolean = useSelector(
    (state: RootState) => state.assetWithoutCampaignDetails.updateDraft.success
  );
  // const assetName: string = useSelector(
  //   (state: RootState) => state.assetWithoutCampaignDetails.assetName
  // );

  const createNewDraftMethod = () => {
    console.log("inside create new Draft");
    createNewDraftVersionAssetWithoutCampaign(assetId);
  };

  useEffect(() => {
    console.table(draftEditions);
  }, [updateDraftSuccess]);

  return (
    <>
      <div className="d-flex flex-column">
        <div className="d-flex">
          <Wrapper>
            <div className="div-spacing">
              <Message
                iconClass={"message-icon-style"}
                message={ALERT_MESSAGES.DEFAULT_EMAIL_WITHOUT_CAMPAIGN}
                label="Heads up!"
                type="info"
                marginTop={10}
                marginBottom={10}
                callToAction={() => {
                  return (
                    <CreateAsset
                      noPortal={true}
                      noDropdown={true}
                      updateAsset={true}
                      assetId={assetId?.toString()}
                      name={assetName}
                    // redirectRoute={''}
                    >
                      <span className="save-to-campaign">
                        <ButtonSmall style={{ marginRight: "15px" }} value={"Save"} />
                      </span>
                    </CreateAsset>
                  );
                }}
              />
              <div className="d-flex justify">
                <div className="editions-text-styling clickable">Draft editions</div>
                <div>
                  {/* <a onClick={(e) => {}}> */}
                  <ButtonRightIconGreen
                    icon={PlusIcon}
                    label="New Draft"
                    classIcon="plus15 px-2"
                    onClick={createNewDraftMethod}
                    isLoading={newDraftLoading}
                  />
                  {/* </a> */}
                </div>
              </div>
              {loading ? (
                <>
                  <EmailCardWrapperLoader />
                  <EmailCardWrapperLoader />
                  <EmailCardWrapperLoader />
                </>
              ) : (
                <>
                  {newDraftLoading ? <EmailCardWrapperLoader /> : null}
                  {draftEditions.length > 0 &&
                    draftEditions.map((li: any, index: number) => {
                      if (li.status === "draft") {
                        console.log(li.name);
                        return (
                          <div key={index} className="email-card">
                            <EmailCardWrapper
                              data={li}
                              campaignId={getQueryCampaignId()}
                              assetType={ASSET_TYPE.HYBRID}
                            />
                          </div>
                        );
                      }
                      return null;
                    })}
                </>
              )}
            </div>
          </Wrapper>
          <Wrapper2>
            <PalletButtonSection
              greenText="Edit"
              dateText="Every 2nd Monday, at 10:00a.m"
              data={{}}
              disableGraphAndStats={true}
            />

            <FloatingPopover contentType='email'>
              <FloatingPopoverData />
            </FloatingPopover>
          </Wrapper2>
        </div>
      </div>
    </>
  );
};

export default AssetWithoutCampaignDashboard;

const Wrapper2 = styled.div`
  margin-top: -14em;
  margin-right: -90px;
  width: 350px;
  background-color: #d8d8d82e;
  min-height: calc(100vh + 7px);
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    margin-right: -30px;
    width: 250px;
    min-height: calc(100vh + 51px);
  }
  .most-engaged-styling {
    margin-top: 3em;
  }
  .justify {
    margin-top: 3em;
  }
`;

const Wrapper = styled.div`
  width: calc(100% - 350px);
  margin-right: 6.5em;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    margin-right: 45px;
    width: calc(100% - 250px);
  }
  .img-styling {
    width: 100%;
    margin: 1em 0 3em 0;
  }
  .div-spacing {
    margin-bottom: 3.5em;
  }
  .email-card {
    margin-bottom: 1.5em;
    .card-style {
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        border-radius: 7px;
        height: 100px;
      }
      .ant-card-body {
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          padding: 12px 18px;
        }
      }
    }
  }
  .clickable {
    cursor: pointer;
  }
  .rotate-arrow {
    margin-left: 0.25em;
    width: 14.82px;
    height: 12.11px;
  }
  .justify {
    justify-content: space-between;
    margin-bottom: 1em;
  }
  .editions-text-styling {
    color: #67696a;
    font-size: 22px;
    font-weight: 700;
    line-height: 34px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 16px;
      line-height: 24px;
    }
  }
  .search-bar-styling {
    width: 170px;
  }
  .tabs-wrapper {
    justify-content: space-between;
    align-items: center;
    margin-left: -5px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding-bottom: 12px !important;
    }

    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      display: flex;
      li {
        margin: 5px 5px;
      }
    }
    p.articles-count {
      margin-bottom: 0px;
      color: rgb(126, 126, 126);
      font-size: 14px;
      font-weight: 600;
      font-family: "robotomedium";
      white-space: nowrap;
      display: inline-block;
      /* float: right; */
    }
  }
  div[aria-expanded="false"] {
    .rotate-arrow {
      transform: rotate(90deg);
    }
  }
  .bottom-margined-chart {
    margin-bottom: 30px;
    height: 350px;
  }
  /* .bottom-margined-message {
    margin-bottom: 48px;
  } */
  .message-icon-style {
    margin-left: 15px;
  }
`;
